import React, { useState } from 'react';
import Button from './Button';
import Input from './Input';
import { useTranslation } from 'react-i18next';

const MultiFileUpload = ({ label, name, onChange, value = [] }) => {
  const { t } = useTranslation();
  const [documents, setDocuments] = useState(value);

  const handleAddDocument = () => {
    const newDoc = { file: null, url: '', description: '' };
    const updated = [...documents, newDoc];
    setDocuments(updated);
    onChange(updated);
  };

  const handleFileChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      const updated = [...documents];
      updated[index] = { ...updated[index], file, url };
      setDocuments(updated);
      onChange(updated);
    }
  };

  const handleDescriptionChange = (index, description) => {
    const updated = [...documents];
    updated[index] = { ...updated[index], description };
    setDocuments(updated);
    onChange(updated);
  };

  const handleRemoveDocument = (index) => {
    const updated = documents.filter((_, i) => i !== index);
    setDocuments(updated);
    onChange(updated);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      
      <div className="space-y-3">
        {documents.map((doc, index) => (
          <div key={index} className="border border-gray-300 rounded-lg p-3 bg-gray-50">
            <div className="flex items-start gap-2">
              <div className="flex-1 space-y-2">
                <div className="flex items-center gap-2">
                  <input
                    type="file"
                    onChange={(e) => handleFileChange(index, e)}
                    className="text-sm file:mr-2 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                  />
                  {doc.file && (
                    <span className="text-xs text-gray-600 truncate max-w-xs">
                      {doc.file.name}
                    </span>
                  )}
                </div>
                
                <Input
                  placeholder={t('ddp.documentDescription')}
                  value={doc.description}
                  onChange={(e) => handleDescriptionChange(index, e.target.value)}
                  className="text-sm"
                />
              </div>
              
              <button
                type="button"
                onClick={() => handleRemoveDocument(index)}
                className="text-red-600 hover:text-red-800 font-bold text-lg px-2"
                title={t('common.remove')}
              >
                ×
              </button>
            </div>
          </div>
        ))}
      </div>

      <Button
        type="button"
        onClick={handleAddDocument}
        variant="secondary"
        className="mt-3"
      >
        {t('ddp.addDocument')}
      </Button>

      {documents.length > 0 && (
        <div className="mt-2 text-xs text-gray-500">
          {documents.length} {t('ddp.documentsCount')}
        </div>
      )}
    </div>
  );
};

export default MultiFileUpload;
